export const validateTeamName = (teamName: string, existingTeams: string[] = []): string | undefined => {
  const name = teamName.trim();
  if (!name) {
    return "Team name is required";
  }
  if (name.length < 2 || name.length > 50) {
    return "Team name must be between 2-50 characters";
  }
  if (!/^[a-zA-Z0-9\s-]+$/.test(name)) {
    return "Team name can only contain letters, numbers, spaces, and hyphens";
  }
  if (existingTeams.includes(name)) {
    return `"${name}" is already in your list`;
  }
  return undefined;
};

export const validateForm = (formState: any) => {
  const newErrors: any = {};

  if (!formState.teamNames || formState.teamNames.length === 0) {
    newErrors.teamNames = "Add at least one team";
  }

  if (formState.reminderMethod === 'sms') {
    if (!formState.phoneNumber) {
      newErrors.phoneNumber = "Phone number is required when SMS is selected";
    } else if (!/^\+\d{5,15}$/.test(formState.phoneNumber)) {
      newErrors.phoneNumber = "Please enter a valid international phone number starting with +";
    }
  }

  if (formState.reminderMethod === 'telegram') {
    if (!formState.telegramChatId) {
      newErrors.telegramChatId = "Telegram chat ID is required when Telegram is selected";
    } else if (!/^\d+$/.test(formState.telegramChatId)) {
      newErrors.telegramChatId = "Telegram chat ID must contain only numbers";
    }
  }

  return newErrors;
};
